var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as ProfileActions from '../../actions/profile/profile';
import * as WithdrawActionType from '../../actions/withdraw/withdraw';
import { SUCCESS_PHONE_CREATE_CONFIRMATION } from '../../actions/phoneConfirmation';
var initialState = {
    updateResult: undefined,
    createConfirmStatus: undefined,
    fetching: false,
    gambler: {},
    reqData: null,
    formType: 'profile',
};
export default function profileReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ProfileActions.UPDATE_PROFILE_INFO:
            return __assign(__assign({}, state), { fetching: false, reqData: action.data, formType: 'profile' });
        case ProfileActions.CLEAR_UPDATED_RESULT_PROFILE: {
            return __assign(__assign({}, state), { updateResult: undefined });
        }
        case ProfileActions.SUCCESS_UPDATE_PROFILE_INFO:
            var updateResult = action.data.Result || 0;
            var reqData = state.reqData;
            var gambler = state.gambler;
            if (updateResult === 0) {
                if (reqData.firstName) {
                    gambler['firstName'] = reqData.firstName;
                }
                if (reqData.lastName) {
                    gambler['lastName'] = reqData.lastName;
                }
                if (reqData.email) {
                    gambler['email'] = reqData.email;
                }
                if (reqData.city) {
                    gambler['city'] = reqData.city;
                }
                if (reqData.countryId) {
                    gambler['countryId'] = reqData.countryId;
                }
            }
            return __assign(__assign({}, state), { updateResult: updateResult, gambler: gambler, fetching: false, formType: 'profile' });
        case SUCCESS_PHONE_CREATE_CONFIRMATION:
            if (action.data.Error !== undefined) {
                return __assign(__assign({}, state), { createConfirmStatus: -10000 });
            }
            else {
                return __assign(__assign({}, state), { createConfirmStatus: 0 });
            }
        case ProfileActions.SUCCESS_FETCH_GAMBLER:
            var data = action.data;
            return __assign(__assign({}, state), { gambler: __assign({ 'birthdate': data.Birthdate, 'city': data.City, 'countryId': data.CountryId, 'email': data.Email, 'firstName': data.FirstName, 'lastName': data.LastName, 'phone': data.Phone, 'phoneConfirmed': data.PhoneConfirmed, 'selfBlockingEndDate': data.SelfBlockingEndDate, 'selfBlockingUnlock': data.SelfBlockingUnlock, 'isVerified': data.IsVerified }, action.data) });
        case WithdrawActionType.SUCCESS_FETCH_WITHDRAW_DATA:
            return __assign(__assign({}, state), { gambler: {
                    'birthdate': action.data.profile.Birthdate,
                    'city': action.data.profile.City,
                    'countryId': action.data.profile.CountryId,
                    'email': action.data.profile.Email,
                    'firstName': action.data.profile.FirstName,
                    'isVerified': action.data.profile.IsVerified,
                    'lastName': action.data.profile.LastName,
                    'phone': action.data.profile.Phone,
                    'phoneConfirmed': action.data.profile.PhoneConfirmed,
                    'selfBlockingEndDate': action.data.profile.SelfBlockingEndDate,
                    'selfBlockingUnlock': action.data.profile.SelfBlockingUnlock,
                } });
        case ProfileActions.CHANGE_PROFILE_PASSWORD:
            return __assign(__assign({}, state), { fetching: true, formType: 'password' });
        case ProfileActions.CHANGE_PROFILE_PASSWORD_SUCCESS:
            return __assign(__assign({}, state), { fetching: false, updateResult: action.data.Result, formType: 'password' });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/profile/profileReducer.js